<template >
  <transition name="fade" mode="out-in">

    <div class="app c-app flex-row align-items-center">

      <CContainer class="container-fluid h-100">
        <CCard
          bodyWrapper
          class="h-100 justify-content-center align-items-center base"
        >

        <!-- <div style="align-content: center;text-align: center;">
          <img class="navbar-brand-minimized mb-4" src="logo/logo.png"  height="70" alt="MIMOTO - Área privada clientes Mimoto">
        </div> -->

          <CRow style="padding-top: 5rem; padding-bottom: 7rem">
            <div
              class="col-md-12"
              style="align-content: center; text-align: center"
            >
              <LoaderRoller class="mb-4" />

              <h1 class="text-white mr-4">Procesando la respuesta</h1>

            </div>
          </CRow>
        </CCard>
      </CContainer>
   </div>
  </transition>
</template>

<script>

import LoaderRoller from "@/app/shared/components/LoaderRoller";

import  { TPV_RESPONSE_TYPES } from '@/config';

export default {
  // name: '',
  components: {
    // LayoutDefault
    LoaderRoller,
  },

  data() {
    return {
      Ds_MerchantParameters: null,
      orderType: null,
      TPV_RESPONSE_TYPES: TPV_RESPONSE_TYPES
    };
  },

  computed: {
    amount: function () {
      let price = this.Ds_MerchantParameters.Ds_Amount;
      let amount_main = price.substring(0, price.length - 2);
      let amount_dec = price.substring(price.length - 2, price.length);
      return `${amount_main}.${amount_dec}`;
    },
  },

  mounted() {
    this.$nextTick(async () => {

      if (this.$route.query.r){
        this.orderType = this.$route.query.r;
        this.returnTo();
        
      } else {
        this.$router.push('/login');
      }

    });
  },
  methods: {
    returnTo() {
      const URL = this.setRedirecction();
      this.$router.push(URL);
    },

    setRedirecction() {
      // let type = this.orderType;
      // const CODE = type.substring(0, 2);

      if (this.orderType.includes(this.TPV_RESPONSE_TYPES.RC)) {
        // return "clientes/acceso?ok=true";
        return "tpv-response?ok=true&vld=true";
      }

      if (this.orderType.includes(this.TPV_RESPONSE_TYPES.MP)) {
        return "configuracion/metodo-pago?ok=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.CP) ) {
        // return "configuracion/mi-cuenta?ok=true";
        return "parkings?ok=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.PC) ) {
        return "tpv-response?ok=true";
      }

      if ( this.orderType.includes(TPV_RESPONSE_TYPES.PE) ) {
        return "tpv-response?ok=true";
      }

      
      // https://front.mimotov2.trestristestigres.com/#/tpv-pago-ok?r=322PE000188&h=235c16b5e899bdb14d0054ebbaf625fd&ret=0&i=0

      // tpv-pago-ok?r=322PE000188&h=235c16b5e899bdb14d0054ebbaf625fd&ret=0&i=0

      /**

        from=MP / RC / CP 

        RC - registro cliente
        MP - método de pago
        CP - Contratar producto. nueva tarjeta en form contratación
        'PC' => 'PC000', // pay Custom
        'PE' => 'PE000', // pay extra

      */

    },

  },

  /*

  {
  "TransactionType":"107",
  "TransactionName":"Bankstore IFrame add_user",
  "CardCountry":"USA","DateTime":"20210928160520",
  "Signature":"51b3c20efdcb25b9f2ba8ebd8f048c4a",
  "NotificationHash":"f669a06664380c711a8685231fe704eb8596f052ed3dc8ba73ae1cc6c71b391bd6d4b6931afcd3a65b81d003307cf4ef8d5f207b64c40363604198be3f1cca55","Order":"RC0009",
  "Response":"OK",
  "ErrorID":"0",
  "Language":"es",
  "AccountCode":"du7ybfr6",
  "TpvID":"26345",
  "IdUser":"53615215",
  "TokenUser":"ZkRZc0xpNXRQVzF",
  "CardType":"CREDIT",
  "Concept":null,
  "Method":"1",
  "MethodName":"Tarjeta",
  "sepaCard":"0",
  "cardCategory":"CONSUMER",
  "cardType":"CREDIT"
  }

array(4) { ["r"]=> string(10) "FORM121284" ["h"]=> string(32) "b13d37b297f7b4a5b59c941d79c8bb71" ["ret"]=> string(1) "0" ["i"]=> string(2) "26" }


  */

};
</script>

<style lang="scss" scoped>
.base {

  background: rgb(61, 173, 168);
  background: linear-gradient(
    90deg,
    rgba(61, 173, 168, 1) 35%,
    rgba(0, 212, 255, 1) 100%
  );
}

.app {
  width: 100%;
  background-image: url("~@/assets/img/login-background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  // margin-top: $header;
  position: relative;

  @media (min-width: 768px) {
    min-height: 100vh;
  }

  & > * {
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    // background-color: rgba(#a8d7e7, 0.5);//#f3f6f9; #A6C4CE  2d5b83
    background-color: rgba(255, 255, 255, 0.77);  // 0.87
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.9;
  }

}


</style>
